import config from "../utils/config/config";
import { uuidGenerator } from "../utils/general";
import { BotApiServices } from "./api/BotApiServices";
import { UserServiceClientApi } from "./api/UserApiServices";
import GenericAjax from "./GenericAjax";
const userImageBaseUrl = config.userImageBaseUrl;
const filesAPI = config.filesAPI;

export const isFileFromS3 = (fileName) => {
	return (
		fileName &&
		(fileName.startsWith("http://") || fileName.startsWith("https://"))
	);
};

// export const fileToBase64 = (file)=> {
//   return new Promise((resolve, reject) => {
//     // Check if the file is of type File or Blob
//     if (file instanceof File || file instanceof Blob) {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onloadend = () => resolve(reader.result);
//       reader.onerror = reject;
//     } else {
//       reject(new Error('The provided input is not a valid file or blob.'));
//     }
//   });
// }

export function fileToBase64(file) {
	return new Promise((resolve) => {
		let reader = new FileReader();
		reader.onload = function (event) {
			let str = event.target.result;
			let index = str.indexOf(",");
			str = str.substring(index + 1);
			resolve(str);
		};
		reader.readAsDataURL(file);
	});
}


export const getFileName = () => {
	return uuidGenerator();
};

export const getFileBaseUrl = (fileName = null) => {
	if (fileName) {
		if (isFileFromS3(fileName)) {
			return fileName;
		}
		return `${userImageBaseUrl}/${fileName}`;
	} else {
		return `${userImageBaseUrl}`;
	}
};

export function getFileUrl(folderName, fileName = null) {
	if (fileName) {
		if (isFileFromS3(fileName)) {
			return fileName;
		}
		return `${filesAPI}/file/${folderName}/${fileName}`;
	} else {
		return `${filesAPI}/file/${folderName}`;
	}
};

function fetchFileFromS3(url) {
	return fetch(url, { mode: "no-cors" })
		.then((response) => response.blob())
		.then((blobRes) => {
			return URL.createObjectURL(blobRes);
		});
};

export function getFileUsingUrl(url) {
	if (url.startsWith(userImageBaseUrl)) {
		return BotApiServices.downloadFile(url).then(function (res) {
			return URL.createObjectURL(res.data);
		});
	}
	else {
		return fetchFileFromS3(url);
	}
};

export function getProfilePhoto(fileName) {
	return getFileUsingUrl(getFileUrl(fileName));
};


export async function uploadFileWithSignedUrl(
  signedUrl,
  fileData,
) {
  try {
    if (!signedUrl || !fileData) {
      return;
    }

    const response = await fetch(signedUrl, {
      method: "PUT",
      headers: {
        "Content-Encoding": "base64"
      },
      body: fileData
    });

    const statusCode = response.status;
    console.log("Status Code:", statusCode);

    if (statusCode === 200 || statusCode === 201) {
      let responseData = null;
      let json = {};

    //   try {
    //     const text = await response.text();
    //     if (text) {
    //       responseData = text;
    //       json = JSON.parse(text);
    //       console.log("Upload Success JSON:", json);
    //     }
		
    //   } catch {
    //     console.log("Upload success but JSON parse failed");
    //   }
    } else {
      const errorText = await response.text();
      console.log("Upload failed:", errorText || statusCode);

    }
	return response
  } catch (error) {
    console.log("Upload failed:", error.message);
  }
}
